import React from 'react'
import { Menu } from 'antd'
import {
  Switch,
  Redirect,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { OrganizationOverlay, Page, PrivateRoute } from '~/Components'

import styles from './Organizations.module.less'
import { useAppDispatch } from '~/Store/hooks'
import { OrganizationActions } from '~/Store/Organization'
// eslint-disable-next-line import/no-cycle
import { OrgRoutes } from '../Routes'
import { useSelector } from 'react-redux'
import { UserSelectors } from '~/Store/User'

export const Organizations = () => {
  const location = useLocation()
  const history = useHistory()
  const match = useRouteMatch()
  const dispatch = useAppDispatch()
  const orgRoles = useSelector(UserSelectors.getOrgRoles)
  const { t } = useTranslation()

  const navigate = (path: string) => {
    if (path !== '') {
      dispatch(OrganizationActions.setIsEditMode(false))
    }
    history.push(`${match.path}${path}`)
  }

  // Sub-pages (e.g. /ApiKeys/New) are routed but never rendered as their own
  // tab, so highlight the visible tab they were reached from — the longest
  // menu path that prefixes the current URL.
  const activeKeys = (): string => {
    const menuRoutes = OrgRoutes.filter(route => !route.hideFromMenu)
    const currentTab = menuRoutes.find(
      ({ routeProps: { path } }) => `${match.path}${path}` === location.pathname,
    )
    if (currentTab) return currentTab.label

    const parentTab = menuRoutes
      .filter(
        ({ routeProps: { path } }) =>
          path !== '' && location.pathname.startsWith(`${match.path}${path}/`),
      )
      .sort(
        (a, b) =>
          String(b.routeProps.path).length - String(a.routeProps.path).length,
      )[0]
    return parentTab ? parentTab.label : 'info'
  }

  return (
    <OrganizationOverlay>
      <Menu
        mode="horizontal"
        selectedKeys={[activeKeys()]}
        style={{ background: '#FFF' }}
      >
        {OrgRoutes.filter(route => !route.hideFromMenu).map(
          ({ label, routeProps: { path }, orgPermission }) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            <Menu.Item
              key={label}
              onClick={() => navigate(path!.toString())}
              disabled={
                orgPermission.filter(x => orgRoles.includes(x)).length <= 0
              }
            >
              {t(label)}
            </Menu.Item>
          ),
        )}
      </Menu>
      <Page title="header.organizations" className={styles.Organizations}>
        <Switch>
          {OrgRoutes.map(
            ({
              label,
              rootPermission,
              orgPermission,
              routeProps: { path, ...rest },
            }) => (
              <PrivateRoute
                allowedRoles={[...rootPermission, ...orgPermission]}
                key={`${label}`}
                exact
                path={`${match.path}${path}`}
                {...rest}
              />
            ),
          )}
          <Redirect to="/Organizations" />
        </Switch>
      </Page>
    </OrganizationOverlay>
  )
}